import React, { useEffect, useState } from "react"
import { Button, Image, Modal, Sidebar } from "semantic-ui-react"
import { formatText } from "../../../v1/helpers/stringHelpers"
import ReactSVG from "react-svg"
import FuelmanCardLogo from "../../../images/dashboard/fuelman-card.svg"
import FuelmanCardMobileLogo from "../../../images/dashboard/fuelman-card-mobile.svg"
import { useTranslation } from "react-i18next"
import {
  FROM_WHERE_USER_CAME,
  FUELCARD_STATUS,
  getFuelcardUsaaFlag,
  SAVE_UPTO
} from "../../../v1/constants/fuelcardRequest"
import { isMobile } from "react-device-detect"
import { withRouter } from "react-router-dom"
import FuelcardIndex from "../Fuelcard/FuelcardIndex"
import CrossWhiteLogo from "../../../images/cross-white.svg"
import CrossIcon from "../../../images/close-icon.svg"
import { connect } from "react-redux"
import { getFuelcardModalValue, getFuelcards } from "../../../v1/actions/fuelcard"
import ActivateFuelcardBanner from "../Fuelcard/ActivateFuelcardBanner"
import RequestFuelCard from "../RequestFuelCard/RequestFuelCard"
import { trackFirebaseAnalytics } from "../../../shared_component/utils/googleAnalyticsHelpers"
import InfoLogo from "../../../images/info_icon_vector_orange.svg"
import { trackEvent } from "../../../shared_component/utils/segmentAnalytics"

const FuelcardRequest = ({
  getFuelcards,
  user,
  location,
  getFuelcardModalValue,
  showRequestCardModel,
  showCardLockedBanner = true,
  isUsaaUser
}) => {
  const { t } = useTranslation("fuelcardRequest")

  const params = new URLSearchParams(location.search)
  const promoCode = params.get(FROM_WHERE_USER_CAME)

  const [openModal, setOpenModal] = useState(false)
  const [openRequestCardModal, setRequestCardModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isUSaaFlagOn, setIsUsaaFlagOn] = useState(false)
  const [fuelcard, setFuelcard] = useState({})
  const [isApiInProgress, setIsApiInProgress] = useState(false)
  const [cardRequested, setCardRequested] = useState(false)

  const handleRequestCardModal = () => {
    setRequestCardModal((prev) => {
      if (prev) {
        getFormData()
      }
      return !prev
    })

    if (cardRequested) {
      handleFuelcard()
    }
    setOpenModal(false)
  }

  const handleModal = () => {
    setOpenModal((prev) => !prev)
  }

  const handleFuelCardFlag = async () => {
    setIsApiInProgress(true)
    try {
      const flag = await getFuelcardUsaaFlag()
      setIsUsaaFlagOn(flag)
    } catch (error) {
      console.log("Error in handleFuelCardFlag", error)
    } finally {
      setIsApiInProgress(false)
    }
  }

  const handleCloseButton = () => {
    setIsUsaaFlagOn((prev) => !prev)
  }

  const handleFuelcard = async () => {
    setIsLoading(true)
    try {
      const response = await getFuelcards()
      const card = response?.result?.fuel_cards?.[0] || {}
      setFuelcard(card)

      if (
        !card?.application_status ||
        card?.application_status === FUELCARD_STATUS.initiated ||
        card?.application_status === FUELCARD_STATUS.in_progress
      ) {
        // open fuelcard modal based on show_membership_benefits flag value
        handleFuelcardModal()
      }
    } catch (error) {
      console.log("Error in handleFuelcard", error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleFuelcardModal = async () => {
    try {
      const res = await getFuelcardModalValue()
      if (res?.result?.show_membership_benefits) {
        handleModal()
      }
    } catch (error) {
      console.log("Error in handleFuelcardModal", error)
    }
  }

  const handleCardRequestSuccessful = () => {
    setCardRequested(true)
  }

  useEffect(() => {
    // get fuelcard details
    handleFuelcard()
  }, [])

  useEffect(() => {
    // get split.io flag
    handleFuelCardFlag()
  }, [user])

  useEffect(() => {
    if (!user.has_fuel_card && (showRequestCardModel === "true" || isUsaaUser)) {
      setRequestCardModal(true)
      setOpenModal(false)
      trackFirebaseAnalytics({ event: "auto_request_card" })
    } else {
      setRequestCardModal(false)
    }
  }, [user.has_fuel_card])

  const getFormData = () => {
    //
    if (!cardRequested) {
      const data = JSON.parse(window._requestFuelCardScreen.getFormDetails())
      const keys = Object.entries(data)
        .filter(([key, value]) => Boolean(value)) // Check if value is truthy
        .map(([key]) => key)
      trackFirebaseAnalytics({ event: "web_request_card_abandoned", params: { keys: keys } })
      trackEvent("web_request_card_abandoned", {
        message: keys
      })
    }
  }

  return isApiInProgress || isLoading ? null : isUSaaFlagOn ? (
    <>
      {fuelcard?.status === FUELCARD_STATUS.blocked && showCardLockedBanner && (
        <div className="card-locked-banner">
          <Image src={InfoLogo} width="20px" />
          <div>
            <p className="message">{t("cardLocked")}</p>
            <p className="sub-message">{t("pleaseContact")}</p>
          </div>
        </div>
      )}
      <div className="fuelcard-request">
        {
          // Application Status is not present
          !fuelcard?.application_status ||
          fuelcard?.application_status === FUELCARD_STATUS.initiated ||
          fuelcard?.application_status === FUELCARD_STATUS.in_progress ? (
            <>
              <ReactSVG className="close-logo" onClick={handleCloseButton} src={CrossWhiteLogo} />
              <div className="fuelcard-request-action">
                <p className="fuelcard-request-action-info">
                  {formatText(
                    t(isMobile ? "fuelcardLabelMobile" : "fuelcardLabel", { save: SAVE_UPTO }),
                    "fuelcard-request-action-info-bold"
                  )}
                </p>
                <div className="action-button">
                  <Button
                    onClick={() => {
                      trackFirebaseAnalytics({ event: "click_request_now" })
                      handleRequestCardModal()
                    }}
                    className="request-now"
                  >
                    {t("requestNow")}
                  </Button>
                  <Button
                    onClick={() => {
                      trackFirebaseAnalytics({ event: "click_learn_more" })
                      handleModal()
                    }}
                    className="learn-more"
                  >
                    {t("learnMore")}
                  </Button>
                </div>
              </div>
              <ReactSVG
                className="fuelcard-request-image"
                src={isMobile ? FuelmanCardMobileLogo : FuelmanCardLogo}
              />
            </>
          ) : fuelcard?.application_status === FUELCARD_STATUS.pending_activation ||
            fuelcard?.application_status === FUELCARD_STATUS.pending_card_generation ? (
            <ActivateFuelcardBanner fuelCard={fuelcard} />
          ) : null
        }

        {isMobile ? (
          <Sidebar
            animation="overlay"
            direction="bottom"
            vertical
            visible={openModal}
            className="side-panel-container"
          >
            <FuelcardIndex
              handleRequestCardModal={handleRequestCardModal}
              handleDrawer={handleModal}
            />
          </Sidebar>
        ) : (
          <Modal open={openModal} className="fuelcard-dialog">
            <Modal.Content>
              <FuelcardIndex
                handleRequestCardModal={handleRequestCardModal}
                handleDrawer={handleModal}
              />
            </Modal.Content>
          </Modal>
        )}

        <Modal open={openRequestCardModal} className="request-fuelcard-dialog">
          <Modal.Content>
            <div className="close-logo" onClick={handleRequestCardModal}>
              <Image src={CrossIcon}></Image>
            </div>
            <RequestFuelCard handleChange={handleCardRequestSuccessful} />
          </Modal.Content>
        </Modal>
      </div>
    </>
  ) : null
}

const mapStateToProps = (state) => {
  return {
    user: state.user
  }
}

export default withRouter(
  connect(mapStateToProps, { getFuelcards, getFuelcardModalValue })(FuelcardRequest)
)
